import {
  fetchLessonClassGroupMeeting,
  fetchLessonClassOpenGroupMeeting,
} from "classroom/api/teacher";
import type { ClassroomLessonClassOpenGroupMeeting } from "classroom/types";
import type { GroupMeeting } from "meetings/group-meeting/types";
import { isAxiosError } from "axios";
import { defineStore } from "pinia";

export const useClassroomLessonClassGroupMeetingStore = defineStore(
  "classroomLessonClassGroupMeeting",
  () => {
    const loadGroupMeeting = async (
      scheduleId: string,
      signal?: AbortSignal,
    ): Promise<GroupMeeting> => {
      return fetchLessonClassGroupMeeting(scheduleId, signal);
    };

    // No open meeting is a normal state for the tab, not an error.
    const loadOpenGroupMeeting = async (
      scheduleId: string,
      signal?: AbortSignal,
    ): Promise<ClassroomLessonClassOpenGroupMeeting | null> => {
      try {
        return await fetchLessonClassOpenGroupMeeting(scheduleId, signal);
      } catch (error) {
        if (isAxiosError(error) && error.response?.status === 404) {
          return null;
        }
        throw error;
      }
    };

    return { loadGroupMeeting, loadOpenGroupMeeting };
  },
);
